import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_bahr-rimal-system/artifacts/xdruqubd_IMG_6467.JPG";
const WHATSAPP_NUMBER = "218915224966";
const PHONE_NUMBER = "0915224966";

export const Footer = () => {
  const { t, isRTL } = useLanguage();

  return (
    <footer className="bg-[#0f172a] text-white">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={LOGO_URL} 
                alt="بحر الرمال" 
                className="w-14 h-14 rounded-full object-cover border-2 border-[#38bdf8]"
              />
              <div>
                <h3 className="font-heading font-bold text-lg">
                  {isRTL ? "شركة بحر الرمال" : "Bahr Al Rimal"}
                </h3>
                <p className="text-sm text-slate-400">
                  {isRTL ? "بحر الرمال" : "بحر الرمال"}
                </p>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              {isRTL 
                ? "شركة رائدة في توزيع الأدوية في ليبيا منذ 2012. الموزع الرئيسي لمنتجات لينى للفيتامينات والمكملات الغذائية."
                : "Leading medical distribution company in Libya since 2012. Main distributor for Lynae Vitamins and Supplements."}
            </p>
            <p className="text-slate-400 text-sm">
              {isRTL ? "لإستيراد الأدوية والمعدات الطبية" : "Medicine & Medical Equipment Import"}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">{t("quickLinks")}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-[#d4af37] transition-colors">
                  {t("home")}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-[#d4af37] transition-colors">
                  {t("about")}
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-slate-400 hover:text-[#d4af37] transition-colors">
                  {t("products")}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-[#d4af37] transition-colors">
                  {t("contact")}
                </Link>
              </li>
            </ul>
            
            {/* Staff Portals */}
            <div className="mt-6 pt-4 border-t border-slate-700">
              <p className="text-slate-500 text-xs mb-3">
                {isRTL ? "بوابات الموظفين" : "Staff Portals"}
              </p>
              <ul className="space-y-2">
                <li>
                  <Link to="/driver/login" className="text-slate-400 hover:text-[#d4af37] transition-colors text-sm flex items-center gap-2">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
                    </svg>
                    {isRTL ? "بوابة السائقين" : "Driver Portal"}
                  </Link>
                </li>
                <li>
                  <Link to="/admin" className="text-slate-400 hover:text-[#d4af37] transition-colors text-sm flex items-center gap-2">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    {isRTL ? "لوحة الإدارة" : "Admin Panel"}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">{t("categories")}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/products?category=vitamins" className="text-slate-400 hover:text-[#d4af37] transition-colors">
                  {isRTL ? "فيتامينات" : "Vitamins"}
                </Link>
              </li>
              <li>
                <Link to="/products?category=supplements" className="text-slate-400 hover:text-[#d4af37] transition-colors">
                  {isRTL ? "مكملات غذائية" : "Supplements"}
                </Link>
              </li>
              <li>
                <Link to="/products?category=medical-supplies" className="text-slate-400 hover:text-[#d4af37] transition-colors">
                  {isRTL ? "مستلزمات طبية" : "Medical Supplies"}
                </Link>
              </li>
              <li>
                <Link to="/products?category=skincare" className="text-slate-400 hover:text-[#d4af37] transition-colors">
                  {isRTL ? "العناية بالبشرة" : "Skincare"}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">{t("contactUs")}</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#d4af37] mt-0.5 flex-shrink-0" />
                <span className="text-slate-400 text-sm">{t("tripoliLibya")}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#d4af37] flex-shrink-0" />
                <a href={`tel:${PHONE_NUMBER}`} className="text-slate-400 hover:text-[#d4af37] transition-colors text-sm">
                  {PHONE_NUMBER}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#d4af37] flex-shrink-0" />
                <a href="mailto:info@bahralrimal.ly" className="text-slate-400 hover:text-[#d4af37] transition-colors text-sm">
                  info@bahralrimal.ly
                </a>
              </li>
            </ul>
            
            {/* WhatsApp CTA */}
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}`}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-full transition-colors"
              data-testid="footer-whatsapp"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              {t("whatsappUs")}
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} {isRTL ? "شركة بحر الرمال" : "Bahr Al Rimal"}. {t("allRightsReserved")}.
          </p>
          <p className="text-slate-500 text-sm">
            {t("established")} 2012 • {t("tripoliLibya")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
